import styled from 'styled-components'
import PageCalling from 'src/components/common/PageCalling'
import {useParams} from 'react-router-dom'
import {JoinFormType, PramsKeys} from 'src/types/type'
import useAPI from 'src/hooks/useAPI'
import {useRecoilState, useRecoilValue, useSetRecoilState} from 'recoil'
import {
    PartnerListData,
    TelTypeState,
    uiData, uiVerifyStyle, RecoilStateList, TermsListState,
} from 'src/recoil/common'
import useMoveScroll from 'src/hooks/useMoveScroll'
import {useEffect, useState} from 'react'
import Banner from 'src/components/common/Banner'
import PhoneVerification from 'src/components/views/mkt04/PhoneVerification'
import Terms from 'src/components/views/mkt04/Terms'
import JoinSubmit from 'src/components/views/mkt04/JoinSubmit'
import Footer from 'src/components/views/mkt04/Footer'
import {convertTermsData} from 'src/service/join'
import useSubmitWithModal from "src/hooks/useSubmitWithModal";
import {ModalContextProvider} from "src/components/views/mkt04/Modal/provider";
import Modal from "src/components/views/mkt04/Modal";
import {NoticeFeeText, NoticeText, NoticeWrap} from "src/styles/styledcomponent/views/mkt04/JoinSubmit";
import {useToast} from "src/hooks/useToast";
import Toast from "src/components/views/mkt04/ToastPopup";
import {LayoutGroup, motion, MotionConfig, Transition} from "framer-motion";
import {FormProvider, useForm} from "react-hook-form";
import VulnerableCheckModal from 'src/components/views/join/VulnerableCheckModal'


const Mkt04Inner = () => {
    const {isShow, message, openToast} = useToast(2200);
    const {pcode, telecom} = useParams<PramsKeys>()
    const submit = useSubmitWithModal(pcode ?? '', {openToast});
    const termsApi = useAPI('requestTermsList')
    const {cashSpace} = useRecoilValue(uiVerifyStyle)
    const {CertNum} = useRecoilValue(RecoilStateList);

    const setTermsListState = useSetRecoilState(TermsListState)
    const [partnerData, setPartnerData] = useRecoilState(PartnerListData)
    const setTelType = useSetRecoilState(TelTypeState)
    const {RefElement, onMoveToElement, RefInput} = useMoveScroll()
    const setUiData = useSetRecoilState(uiData)

    const {
        data: getTermsData,
        isSuccess,
        isLoading,
    } = termsApi?.useSetQuery({PCode: pcode})

    const isErrorPartner = getTermsData?.Header.ErrCode === 1011

    useEffect(() => {
        if (isSuccess && !isErrorPartner) {
            const data = getTermsData?.Body
            const telecomNumber = telecom ? Number(telecom) : 0;
            setTelType(telecomNumber)
            setTermsListState(convertTermsData(data))
            setPartnerData(data?.Partner)
            setUiData(JSON.parse(atob(data?.Partner.UiData)))
        }
        // eslint-disable-next-line
    }, [isSuccess, isErrorPartner, getTermsData?.Body, setPartnerData, setTermsListState, setTelType, setUiData])

    const isCertFilled = (CertNum?.length ?? 0) === 4;
    const [didFlip, setDidFlip] = useState(false);
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
        if (!didFlip && isCertFilled) setDidFlip(true);
    }, [isCertFilled, didFlip]);

    const SPRING: Transition = {type: 'spring', stiffness: 380, damping: 30, mass: 1.2} as const

    return (
        <Mkt04Wrap>
            <PageCalling active={isLoading}/>
            {isSuccess && (
                <>
                    <Banner RefElement={RefElement}/>
                    <>
                        <PhoneVerification
                            onMoveToElement={onMoveToElement}
                            RefInput={RefInput}
                            submit={submit}
                            openToast={openToast}
                        />
                        <MotionConfig transition={{layout: {duration: 0}}}>
                            <LayoutGroup id="mkt04">
                                <SwitchComp as={motion.div} layout initial={false}>
                                    {(didFlip ? ['join', 'terms'] : ['terms', 'join']).map(key => (
                                        <motion.div
                                            key={key}
                                            layout={isMounted}
                                            initial={false}
                                            layoutDependency={didFlip}
                                            transition={didFlip ? SPRING : {duration: 0}}
                                        >
                                            {key === 'terms'
                                                ? (!isErrorPartner && <Terms/>) : <JoinSubmit submit={submit}/>}
                                        </motion.div>
                                    ))}
                                </SwitchComp>
                            </LayoutGroup>
                        </MotionConfig>
                        <NoticeWrap>
                            <NoticeText
                                cashSpace={cashSpace}
                                fontSize={partnerData.FontSize}
                            >본 서비스는 통신3사 제휴 부가서비스로 (주)데이터유니버스에서 운영합니다.
                            </NoticeText>
                            <NoticeFeeText
                                cashSpace={cashSpace}
                                fontColor={partnerData.FontColor}
                                fontSize={partnerData.FontSize}
                                dangerouslySetInnerHTML={{__html: partnerData.NotiContent}}
                            />
                        </NoticeWrap>
                        <Footer/>
                    </>
                </>
            )}
            <Toast show={isShow} message={message}/>
            <VulnerableCheckModal submit={submit} />
        </Mkt04Wrap>
    )
}


export default function Index() {
    const methods = useForm<JoinFormType>({
        mode: 'onSubmit',
        defaultValues: {
            PNumber: '',
            TranID: '',
            ApprovalNumber: '',
        },
    })
    return (
        <FormProvider {...methods}>
            <ModalContextProvider>
                <Mkt04Inner/>
                <Modal/>
            </ModalContextProvider>
        </FormProvider>
    );
}

const Mkt04Wrap = styled.div`
    max-width: 492px;
    margin: 0 auto;
    background-color: #fff;
`

const SwitchComp = styled.div`
    display: flex;
    flex-direction: column;
`;